import { AccountInfo, IPublicClientApplication } from "@azure/msal-browser";
import axios, { AxiosResponse } from "axios";
import LoginService from "../services/LoginService";
import { Account } from "../models/account";
import { SurveyDto } from "../models/surveyDto";
import { StartUserSurveyDto } from "../models/startUserSurveyDto";
import { UserSurveyResultDto } from "../models/userSurveyResultDto";
import SurveyContentTranslations from "../models/surveyContentTranslations";
import { NonWeightedUserResponseDto } from "../models/nonWeightedUserResponseDto";
import { LanguageDto } from "../models/languageDto";
import { toast } from "react-toastify";



axios.defaults.baseURL = process.env.REACT_APP_API_URL + "api/";

const responseBody = <T>(response: AxiosResponse<T>) => response.data;
let msalInstance: IPublicClientApplication;
let account: AccountInfo;

const setMsalData = (instance: IPublicClientApplication, currentAccount: AccountInfo) => {
    msalInstance = instance;
    account = currentAccount;
}

//Acquire access token and append it to the authorization header before invoking the API
axios.interceptors.request.use(async (config) => {
    const loginService = new LoginService();
    const token = await loginService.getAccessToken(msalInstance, account);
    if (token && config.headers)
        config.headers.Authorization = `Bearer ${token}`;
    return config;
});

const requests = {
    get: <T>(url: string, signal?: { signal: AbortSignal }) => axios.get<T>(url, signal).then(responseBody),
    post: <T>(url: string, body: {}) => axios.post<T>(url, body).then(responseBody),
    put: <T>(url: string, body: {}) => axios.put<T>(url, body).then(responseBody),
    delete: <T>(url: string) => axios.delete<T>(url).then(responseBody),
};

const Accounts = {
    current: () => requests.get<Account>("account"),
};

const Surveys = {
    load: (surveyCode: string) => requests.get<SurveyDto>(`surveys/${surveyCode}`),
    info: (surveyCode: string) => requests.get<SurveyDto>(`surveys/${surveyCode}/info`),
    languages: (surveyId: number) => requests.get<LanguageDto[]>(`surveys/${surveyId}/languages`),
};

const FileDownload = require("js-file-download");
const UserSurveys = {
    start: (surveyCode: string, dto: StartUserSurveyDto) => requests.post<number>(`usersurveys/${surveyCode}/start`, dto),
    submit: (survey: SurveyDto) => requests.post<string>(`usersurveys/submit`, survey),
    load: (userSurveyCode: string) => requests.get<UserSurveyResultDto>(`usersurveys/${userSurveyCode}/load`),
    send: (userSurveyCode: string, report: string) => requests.post(`usersurveys/${userSurveyCode}/send`, { reportHtml: report }),
    languages: (userSurveyCode: string) => requests.get<LanguageDto[]>(`usersurveys/${userSurveyCode}/languages`),
    savePreSurveyQuestions: (responses: NonWeightedUserResponseDto[]) => requests.post(`usersurveys/savePreResponses`, responses),
    savePostSurveyQuestions: (responses: NonWeightedUserResponseDto[]) => requests.post(`usersurveys/savePostResponses`, responses),
    saveUserSurveyContactDetails: (dto: StartUserSurveyDto) => requests.post(`usersurveys/savecontactdetails`, dto),
    downloadedCertificate: (userSurveyCode: string) => requests.get<boolean>(`usersurveys/${userSurveyCode}/certificateDownloaded`),
    downloadReport: (userSurveyCode: string, report: string) => {
        axios({
            url: `usersurveys/${userSurveyCode}/download`,
            method: "POST",
            data: { reportHtml: report },
            responseType: "blob",
        }).then((response) => {
            FileDownload(response.data, "report.pdf");
        });
    },
    downloadCertificate: (userSurveyCode: string, userName: string, report: string, t: any) => {
        axios({
            url: `usersurveys/${userSurveyCode}/downloadCertificate`,
            method: "POST",
            data: { reportHtml: report, name: userName ? userName : "" },
            responseType: "blob",
        }).then((response) => {
            FileDownload(response.data, "certificate.pdf");
        }).catch((error) => {
            if (error.response.status === 404)
                toast.error(t("Certificate.CertificateHasBeenDownload"));
        });
    }
};

const Translations = {
    getSurveyContent: (surveyCode: string, language: string) => requests.get<SurveyContentTranslations>(`Translations/${surveyCode}/${language}`),
    getSurveyContentByUserSurveyCode: (surveyCode: string, language: string) => requests.get<SurveyContentTranslations>(`Translations/report/${surveyCode}/${language}`)
}

const Questions = {
    //list: () => requests.get<QuestionDto[]>(`questions`),
    //details: (questionId: number) => requests.get<QuestionDto>(`questions/${questionId}`)
};

const agent = {
    setMsalData,
    Accounts,
    Surveys,
    UserSurveys,
    Questions,
    Translations
};

export default agent;